import styled from "styled-components"

const FooterSocialItem = styled.li`
  &:hover {
    transform: scale(1.05);
    color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
`

export { FooterSocialItem }
